import { takeLatest } from "redux-saga/effects"

import { apiGeneratorBase, apiGeneratorDelete } from "../../../Utils/saga"
import BusinessAccountsActions from "../../BusinessAccountsPage/reducer"
import Creators, { RequestsIntegrationsTypes as constants } from "./reducer"
import * as services from "./services"

const actions = {
  getRequestsIntegrationsActions: {
    request: Creators.getRequestsIntegrationsRequest,
    success: Creators.getRequestsIntegrationsSuccess,
    errors: Creators.requestsIntegrationsFailure
  },
  deleteRequestsIntegrationActions: {
    request: Creators.deleteRequestsIntegrationRequest,
    success: Creators.deleteRequestsIntegrationSuccess,
    errors: Creators.requestsIntegrationsFailure,
    extraAction: [BusinessAccountsActions.getStatisticsAdminRequest]
  },
  getRequestsIntegrationsExportActions: {
    request: Creators.getRequestsIntegrationsExportRequest,
    success: Creators.getRequestsIntegrationsExportSuccess,
    errors: Creators.getRequestsIntegrationsExportFailure
    //downloadFile: true,
  }
}

const eventsOptions = {
  [constants.GET_REQUESTS_INTEGRATIONS_REQUEST]: {
    api: services.getIntegrationsRequests,
    actions: actions.getRequestsIntegrationsActions
  },
  [constants.DELETE_REQUESTS_INTEGRATION_REQUEST]: {
    api: services.deleteIntegrationRequests,
    actions: actions.deleteRequestsIntegrationActions
  },
  [constants.GET_REQUESTS_INTEGRATIONS_EXPORT_REQUEST]: {
    api: services.getRequestsIntegrationsExport,
    actions: actions.getRequestsIntegrationsExportActions
  }
}

export default function* apiSaga() {
  yield takeLatest(constants.GET_REQUESTS_INTEGRATIONS_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_REQUESTS_INTEGRATIONS_REQUEST])
  )
  yield takeLatest(constants.DELETE_REQUESTS_INTEGRATION_REQUEST, (action) =>
    apiGeneratorDelete(action, eventsOptions[constants.DELETE_REQUESTS_INTEGRATION_REQUEST])
  )
  yield takeLatest(constants.GET_REQUESTS_INTEGRATIONS_EXPORT_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_REQUESTS_INTEGRATIONS_EXPORT_REQUEST])
  )
}
